
<template>
    <div v-show="show" class="menuRight" @click.stop="close()">
        <div class="custom-shortcuts" :style="{ left: x + 'px', top: y + 'px' }">
            <div v-for="(item, index) in shortcuts" :class="[{ enabled: !checkDisabled(item.tool) }, { disabled: checkDisabled(item.tool) }]" :key="index" @click="triggerTool(item.tool)">
                <div class="cursorShortcut" :class="[item.tool]"></div>
                <span class="shortcut-txt">{{ item.toolName }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/js/event_bus';
import { store } from '../../store';
import { ALIVE_TYPE, TOOLS } from '../../js/toolbar/tools';

export default {
    name: "MenuRight",
    data: function () {
        return {
            show: false,
            shortcuts: [],
            x: 0,
            y: 0,
            store,
            defaultCustomShortcuts: [
                {
                    show: true,
                    tool: "pen",
                    toolName: "畫筆"
                },
                {
                    show: true,
                    tool: "highlighter",
                    toolName: "螢光筆"
                },
                {
                    show: true,
                    tool: "selection",
                    toolName: "選取"
                },
                {
                    show: true,
                    tool: "eraser",
                    toolName: "橡皮擦"
                },
                {
                    show: true,
                    tool: "text_box",
                    toolName: "文字方塊"
                }
            ]
        }
    },
    methods: {
        setData(data) {
            if(data && data.length > 0) {
                this.shortcuts = data;
            }else {
                this.shortcuts = this.defaultCustomShortcuts;
            }
        },
        close() {
            const self = this;
            setTimeout(() => {
                self.show = false;
            });
        },
        triggerTool: function (tool) {
            if (store.disabledTools.includes(tool)) return;

            console.log("right menu trigger tool:: ", tool);
            if (store.toolMap.get(tool)) {
                switch (store.toolMap.get(tool).KEEP_ALIVE) {
                    case ALIVE_TYPE.KEEP:
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        store.setPreviousTool(tool);
                        break;
                    case ALIVE_TYPE.ONCE:
                        EventBus.getInstance().emit(TOOLS.SELECTION.TOOL);
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        break;
                    case ALIVE_TYPE.NONE:
                        EventBus.getInstance().emit(tool);
                        store.nowTool = store.prevTool;
                        break;
                }
            } else {
                EventBus.getInstance().emit(tool);
                store.nowTool = store.prevTool;
            }


            if (tool == TOOLS.TOOL_BOX.TOOL) {
                return;
            }

            if (tool == TOOLS.GO_PAGE.TOOL) {
                return;
            }

            if (tool == TOOLS.WHITE_BOARD.TOOL) {
                store.setWhiteboardDisabledTools();
            }

            EventBus.getInstance().emit("close_tool_box");
            EventBus.getInstance().emit("close_quick_directory");
        }
    },
    computed: {
        checkDisabled() {
            return (tool) => {
                return store.disabledTools.includes(tool);
            };
        },
    },
    created: function () {
        this.setData();
    }
}
</script>

<style scoped>
@import "@/css/cursor/menuRight.css";

.menuRight {
    position: absolute;
    z-index: var(--z-index-cursor-right-menu);
    width: 100%;
    height: 100%;
}

.custom-shortcuts>div>div {
    width: 64px;
    height: 64px;
    display: inline-block;
    overflow: hidden;
    background-size: cover !important;
}
</style>